import React, { useState, useEffect } from "react";
import Layout from "Components/Layout";
import Loader from "Components/Loader/Loader";
import Swal from "sweetalert2";
import { getSettings } from "Services/ServiceRequest";
import Subloader from "Components/Loader/subload/loader";
import { MdEdit } from "react-icons/md";
import UpdateSettingsModal from "./UpdateSettings";

function Settings() {
    const [loading, setLoading] = useState(true);
    const [Modal, setModal] = useState(false);
    const [Users, setUsers] = useState([]);
    const [selectedItem, setSelected] = useState([]);
    function addSpacesToCamelCase(str) {
        // Capitalize the first letter and add space before capital letters
        if (str) {
            return str
                .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before capital letters
                .replace(/^./, (char) => char.toUpperCase()); // Capitalize the first letter
        }
    }
    const GetRequests = async () => {
        // setLoading(true);
        try {
            const response = await getSettings();
            setLoading(false);
            if (response?.data?.Status === 1) {
                setUsers(response?.data?.configurables);
            } else {
            }
        } catch (err) {
            setLoading(false);
            console.log("err");
            Swal.fire({
                title: "Error",
                text: "Something went wrong please try again",
                icon: "error",
            });
        }
    };

    useEffect(() => {
        GetRequests();
    }, []);

    const EditHandler = (item) => {
        localStorage.setItem("prefillData", JSON.stringify(item));
        setSelected(item);
        setModal(true);
    };
    return (
        <Layout Active={"Config"} showBackButton={false} title={"Admin Users"}>
            <UpdateSettingsModal
                showModal={Modal}
                selectedItem={selectedItem}
                setModal={setModal}
                GetRequests={GetRequests}
                addSpacesToCamelCase={addSpacesToCamelCase}
            />
            <div className="Main_container">
                <h3>Config</h3>
                <Loader loading={loading}>
                    <div className="Table_layout">
                        <table>
                            <thead className="sticky-header">
                                <tr>
                                    <th>Key</th>
                                    <th>Value</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Users.length > 0 ? (
                                    Users.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                {addSpacesToCamelCase(
                                                    item?.key
                                                )}
                                            </td>
                                            <td>{item?.value}</td>
                                            <td>
                                                <div className="Action_btns">
                                                    <button
                                                        onClick={() => {
                                                            EditHandler(item);
                                                        }}>
                                                        <MdEdit />
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        {" "}
                                        <td colSpan={3}>No Data Found</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Loader>
            </div>
        </Layout>
    );
}

export default Settings;
